<div class="wrapper" infinite-scroll [infiniteScrollDistance]="distance" [infiniteScrollThrottle]="throttle" (scrolled)="onScroll()">

    <div class="template-header-section pt-3 pb-3">
      
      <div class="search-bar Custom-Search">
        <input type="search" class="search-input fontSize form-control" [(ngModel)]="searchText"
          placeholder="Search by Name, Service Line, Service Offering etc..."
          (keydown.enter)="searchButton()" (keyup)="clearSearch()" [class.searchClose]="searchText==''">
        <button type="submit" class="msicon" (click)="clearSearchText()" *ngIf="searchText!=''"><span
            class="material-symbols-outlined close-icon"> close </span></button>
        <button type="submit" class="msicon" (click)="searchButton()"><span class="material-symbols-outlined search-icon">
            search</span></button>
      </div>
  
      <div>
        <mat-form-field class="transparent-select custom_select mr-2">
            <mat-select class="dropdown-select" [(ngModel)]="selectedServiceLines" placeholder="Service Line" multiple>
                <ng-container>
                    <div class="dropdown-search-wrapper">
                        <input type="text" [(ngModel)]="serviceLineSearch" placeholder="Search" (input)="filterServiceLines()"
                            class="searchinput" (keydown.space)="$event.stopPropagation()" />
                        <span class="material-symbols-outlined search-icon1">Search</span>
                        <span class="material-symbols-outlined close-icon1" (click)="clearServiceLineFilter()">close</span>
                    </div>
                    <div class="dropdown-scroll-wrapper">
                        <mat-option *ngFor="let i of filteredServiceLines" [value]="i" (click)="toggleServiceLine(i)">
                            <span class="optionValue">{{ i.name }}</span>
                        </mat-option>
                    </div>
                </ng-container>
            </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="transparent-select custom_select mr-2">
            <mat-select
                class="dropdown-select"
                placeholder="Service Offerings"
                [(ngModel)]="selectedServiceOfferings"
                multiple
            >
                <ng-container>
                    <div class="dropdown-search-wrapper">
                        <input type="text" [(ngModel)]="serviceOfferingSearch" placeholder="Search" (input)="filterServiceOfferings()"
                            class="searchinput" (keydown.space)="$event.stopPropagation()" />
                        <span class="material-symbols-outlined search-icon1">Search</span>
                        <span class="material-symbols-outlined close-icon1" (click)="clearServiceOfferingFilter()">close</span>
                    </div>
                    
                    <div class="dropdown-scroll-wrapper">
                        <mat-option *ngFor="let i of filteredServiceOfferings" [value]="i" (click)="toggleServiceOffering(i)">
                            <span class="optionValue">{{ i.name }}</span>
                        </mat-option>
                    </div>
                    </ng-container>
                <!-- <div *ngIf="selectedServiceLines.length!=0">
                    <mat-option *ngFor="let i of serviceOfferingForDropDown" [value]="i">
                        <mat-checkbox matRipple matRippleDisabled="true" [checked]="selectedServiceOfferings.includes(item)" (click)="$event.stopPropagation()">
                            {{i.name}}
                        </mat-checkbox>
                      </mat-option>
                </div> -->
            </mat-select>
          </mat-form-field>
      </div>
      <div>
        <mat-form-field class="transparent-select custom_select mr-2">
            <mat-select class="dropdown-select" [(ngModel)]="selectedTechstack" placeholder="Tech Stack" multiple>
                <ng-container>
                    <div class="dropdown-search-wrapper">
                        <input type="text" [(ngModel)]="techStackSearch" placeholder="Search" (input)="filterTechStacks()"
                            class="searchinput" (keydown.space)="$event.stopPropagation()" />
                        <span class="material-symbols-outlined search-icon1">Search</span>
                        <span class="material-symbols-outlined close-icon1" (click)="clearTechStackFilter()">close</span>
                    </div>
                    
                    <div class="dropdown-scroll-wrapper">
                        <mat-option *ngFor="let i of filteredTechStacks" [value]="i" (click)="toggleTechStack(i)">
                            <span class="optionValue">{{ i.name }}</span>
                        </mat-option>
                    </div>
                    </ng-container>
            </mat-select>
          </mat-form-field>
      </div>
    </div>
    <ng-container class="container-fluid" *ngIf="!searchResultsViewFlag">
        <div class="row m-0">
            <div class="col-12 col-lg-10 pl-0">
                <div class="docs">
                    <div>
                        <div class="fs-18 fw-600 pb-2 pt-3 docs_heading" id="carousel" class="docs_inner pt-3 pb-3">
                            <i
                                class="arrow-icon fas fa-arrow-left"
                                [ngbTooltip]="goBack"
                                tooltipClass="custom_tooltip"
                                placement="top-start"
                                triggers="manual"
                                #goBack1="ngbTooltip"
                                (mouseleave)="goBack1.close()"
                                (mouseover)="goBack1.open()"
                                (click)="navigateBack()"
                            ></i>
                            <ng-template
                                #goBack
                                class="custom_tooltip"
                            >Go Back</ng-template>
                            <span style="font-weight: bold;">
                                Proof Of Concepts Dashboard: 
                            </span>
                            <span>Showcasing innovative Gen AI solutions across business functions and industries.</span>
                            <div class="view">
                                <button class="button-icon" *ngIf="isSuperAdmin" (click)="addPOC()"><span
                                    class="material-symbols-outlined recently-upladed-icons"> add_box </span></button>
                                <button class="button-icon" (click)="toggleView('grid')">
                                    <span class="material-symbols-sharp recently-upladed-icons filled-icon">
                                    grid_view
                                    </span></button>
                                <button class="button-icon" (click)="toggleView('table')">
                                    <span class="material-symbols-sharp recently-upladed-icons filled-icon">
                                        view_list
                                        </span>
                                </button>     
                                <button class="button-icon" *ngIf="isSuperAdmin" [disabled]="!isSuperAdmin" (click)="exportToExcel()"><span
                                    class="material-symbols-outlined recently-upladed-icons"> download </span></button>
                            </div>          
                        </div>
                    </div>
                    <div class="row g-0 ml-0" *ngIf="pocRecords && pocRecords?.length && gridView===false">
                        <div class="col-sm-6 col-md-4 col-lg-4 pl-0" *ngFor="let poc of pocRecords">
                        <div class="custom_card">
                            <div class="custom_card_inner">
        
                            <div class="d-flex justify-content-between pb-2">
                                <div class="d-flex">
                                    <div class="card_image">
                                        <img [src]="poc.logoUrl ? poc.logoUrl : 'assets/images/consulting.png'">
                                    </div>
                                    <div class="card_title card_title_main_heading">
                                    <div [ngbTooltip]="titleTooltip" tooltipClass="custom_tooltip" placement="bottom"
                                        triggers="manual" #tooltip="ngbTooltip" (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"  class="bot-title tooltipEllipsis">
                                        <ng-template #titleTooltip class="custom_tooltip">{{poc.title}}</ng-template>
                                        {{poc.title}}
                                    </div>
                                    <div [ngbTooltip]="pocUrl" tooltipClass="custom_tooltip" placement="top"
                                        triggers="manual" #urltooltip="ngbTooltip" (mouseleave)="urltooltip.close()"
                                        (mouseover)="urltooltip.open()">
                                        <a class="link ellipsis_one_line_text" [href]="poc.url" target="_blank" (click)="addLastViewedOn(poc)">
                                            {{ poc.url.length > 30 ? poc.url.substring(0, 30) + "..." : poc.url }}
                                        </a>
                                            <ng-template #pocUrl class="custom_tooltip">{{poc.url}}</ng-template>
                                        </div>
                                    <div class="rating-container">
                                        <span class="rating-point">{{ poc.ratingAverage | number:'1.1-1'}}</span>
                                        <div class="star-rating">
                                            <span class="star"
                                            *ngFor="let star of stars; let i = index"
                                            [ngClass]="{'filled': i < poc.ratingAverage}"
                                            >
                                            &#9733;
                                            </span>
                                        </div>
                                        
                                    </div>
                                </div>
                        
                                </div>
                                <div class="card_menu position-relative d-flex flex-column">
                                    <div class="dropdown d-flex">
           
                                        <span class="material-symbols-outlined fs-16 cursor_pointer" id="dropdownMenuButton"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        more_vert
                                        </span>
           
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <button class="dropdown-item cursor_pointer d-flex align-items-center" *ngIf="isSuperAdmin" (click)="editPOC(poc)">
                                            <span class="material-symbols-outlined fs-16 mr-2">edit</span>
                                            <span>Edit</span>
                                        </button>
                                        <button  class="dropdown-item cursor_pointer d-flex align-items-center" (click)="openOutlookEmail(poc.pointofcontact)">
                                            <span class="material-symbols-outlined fs-16 mr-2">mail</span>
                                            <span>Contact</span>
                                        </button>
                                        <button class="dropdown-item cursor_pointer d-flex align-items-center" *ngIf="isSuperAdmin" (click)="delPocCard(poc)">
                                            <span class="material-symbols-outlined fs-16 mr-2">delete</span>
                                            <span>Delete</span>
                                        </button>
                                        </div>
                                    </div>
                                    <div class="comment mt-2">
                                        <button type="submit" class="msicon comment-btn" (click)="viewRating(poc)"
                                          [ngbTooltip]="comments" tooltipClass="custom_tooltip" placement="top"
                                          triggers="manual" #comments1="ngbTooltip" (mouseleave)="comments1.close()"
                                          (mouseover)="comments1.open()">
                                          <span class="material-symbols-outlined fs-16 mr-2">comment</span>
                                        </button>
                                        <div><span class="comment-point">{{poc.commentsCount}}</span></div>
                                        <ng-template #comments class="custom_tooltip">View Comments</ng-template>
                                      </div>
                                    </div>
                            </div>
                            <div class="d-flex justify-content-between bder-bottom pb-2">
                                <div class="card_metavalue ellipsis_three_line_text" tooltipClass="custom_tooltip"
                                [ngbTooltip]="metaTagTooltip" placement="right" triggers="manual"
                                (click)="metaTagTooltip1.close()" #metaTagTooltip1="ngbTooltip"
                                (mouseleave)="metaTagTooltip1.close()" (mouseover)="metaTagTooltip1.open()">
                                    <ng-template #metaTagTooltip class="custom_tooltip">{{poc.metadata}}</ng-template>
                                    {{poc.metadata}}
                                </div>
                            </div>
                            
                            <div class="d-flex bder-bottom pt-2 pb-2">
                                <div class="w-50 pr-3">
                                <div class="card_label">Owner</div>
                                <div class="card_value tooltipEllipsis" tooltipClass="custom_tooltip"
                                    [ngbTooltip]="ownerTooltip" placement="top bottom" triggers="manual"
                                    (click)="owner.close()" #owner="ngbTooltip" (mouseleave)="owner.close()"
                                    (mouseover)="owner.open()">
                                    <ng-template #ownerTooltip class="custom_tooltip">{{poc.owner}}</ng-template>
                                    {{poc.owner}}
                                </div>
                                </div>
                                <div class="w-50">
                                <div class="card_label">Point of Contact</div>
                                <div class="card_value tooltipEllipsis" [ngbTooltip]="pointOfContactTooltip"
                                    tooltipClass="custom_tooltip" placement="top bottom" triggers="manual"
                                    (click)="pointOfContact.close()" #pointOfContact="ngbTooltip" (mouseleave)="pointOfContact.close()"
                                    (mouseover)="pointOfContact.open()">
                                    <ng-template #pointOfContactTooltip class="custom_tooltip">{{poc.pointofcontact}}</ng-template>
                                    {{poc.pointofcontact}}
                                </div>
                                </div>
                            </div>
        
                            <div class="d-flex bder-bottom pt-2 pb-2">
                                <div class="w-50 pr-3">
                                <div class="card_label">Service Line</div>
                                <div class="card_value ellipsis_one_line_text" tooltipClass="custom_tooltip"
                                    [ngbTooltip]="serviceLineTooltip" placement="top bottom" triggers="manual"
                                    (click)="serviceLine.close()" #serviceLine="ngbTooltip"
                                    (mouseleave)="serviceLine.close()" (mouseover)="serviceLine.open()">
                                    <ng-template #serviceLineTooltip class="custom_tooltip">{{poc.serviceLine}}</ng-template>
                                    {{poc.serviceLine}}
                                </div>
                                </div>
                                <div class="w-50">
                                <div class="card_label">Service Offering</div>
                                <div class="card_value ellipsis_one_line_text" tooltipClass="custom_tooltip"
                                    [ngbTooltip]="serviceOfferingTooltip" placement="top bottom" triggers="manual"
                                    (click)="serviceOffering.close()" #serviceOffering="ngbTooltip"
                                    (mouseleave)="serviceOffering.close()" (mouseover)="serviceOffering.open()">
                                    <ng-template #serviceOfferingTooltip
                                    class="custom_tooltip">{{poc.serviceOffering}}</ng-template>
                                    {{poc.serviceOffering}}
                                </div>
                                </div>
        
                            </div>
        
                            <div class="d-flex pt-2 pb-2">
                                <div class="w-50">
                                    <div class="card_label">Tech Stack</div>
                                    <div class="card_value ellipsis_two_line_text" [ngbTooltip]="pocTagsTooltip"
                                        tooltipClass="custom_tooltip" placement="top bottom" triggers="manual"
                                        (click)="tooltipTags.close()" #tooltipTags="ngbTooltip" (mouseleave)="tooltipTags.close()"
                                        (mouseover)="tooltipTags.open()">
                                        <ng-template #pocTagsTooltip class="custom_tooltip">{{poc.techStack}}</ng-template>
                                        {{poc.techStack}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        </div>
                    </div>
                    <div class="data-grid mb-2" *ngIf=" gridView === true">
                        <table mat-table [dataSource]="dataSource" matSort class="AI_data">
                          <ng-container matColumnDef="Name">
                            <th mat-header-cell *matHeaderCellDef  mat-sort-header class="custom-mat-header-cell"> Name </th>
                            <td mat-cell *matCellDef="let row" class="mat-column-custom"> 
                                <div [matTooltip]="row.title" matTooltipPosition="above" class="tooltipEllipsis">
                                    {{row.title}}
                                </div> 
                            </td>
                          </ng-container>
                          
                          <ng-container matColumnDef="URL">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="custom-mat-header-cell"> URL </th>
                            <td mat-cell *matCellDef="let row" class="mat-column-custom link">
                                <div [matTooltip]="row.url" matTooltipPosition="above" class="tooltipEllipsis">
                                    <a class="tooltipEllipsis" [href]="row.url" target="_blank" (click)="addLastViewedOn(row)">
                                        {{row.url}}</a>
                                </div>   
                            </td>
                          </ng-container>
          
                          <ng-container matColumnDef="Owner">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="custom-mat-header-cell"> Owner </th>
                            <td mat-cell *matCellDef="let row" class="mat-column-custom"> 
                                <div [matTooltip]="row.owner" matTooltipPosition="above" class="tooltipEllipsis">
                                    {{row.owner}}
                                </div> 
                             </td>
                          </ng-container>
                          
          
          
                          <ng-container matColumnDef="PointOfContact">
                            <th mat-header-cell *matHeaderCellDef class="custom-mat-header-cell"> Point of Contact </th>
                            <td mat-cell *matCellDef="let row" class="mat-column-custom"> 
                                <div [matTooltip]="row.pointofcontact" matTooltipPosition="above" class="tooltipEllipsis">
                                    {{row.pointofcontact}}
                                </div> 
                            </td>
                          </ng-container>
          
                          <ng-container matColumnDef="ServiceLine">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="custom-mat-header-cell"> Service Line </th>
                            <td mat-cell *matCellDef="let row" class="mat-column-custom"> 
                                <div [matTooltip]="row.serviceLine" matTooltipPosition="above" class="tooltipEllipsis">
                                    {{row.serviceLine}}
                                </div> 
                            </td>
                          </ng-container>
          
                          <ng-container matColumnDef="ServiceOffering">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="custom-mat-header-cell"> Service Offering </th>
                            <td mat-cell *matCellDef="let row" class="mat-column-custom">
                                <div [matTooltip]="row.serviceOffering" matTooltipPosition="above" class="tooltipEllipsis">
                                    {{row.serviceOffering}}
                                </div> 
                            </td>
                          </ng-container>
          
                          <ng-container matColumnDef="TechTags">
                            <th mat-header-cell *matHeaderCellDef class="custom-mat-header-cell"> Tech Stack </th>
                            <td mat-cell *matCellDef="let row" class="mat-column-custom"> 
                                <div [matTooltip]="row.techStack" matTooltipPosition="above" class="tooltipEllipsis">
                                    {{row.techStack}}
                                </div> 
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="Rating">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="custom-mat-header-cell"> Rating </th>
                            <td mat-cell *matCellDef="let row" class="mat-column-rating">
                                <div class="rating-container">
                                    <span class="rating-point">{{ row.ratingAverage | number:'1.1-1'}}</span>
                                    <div class="star-rating">
                                        <span class="star"
                                        *ngFor="let star of stars; let i = index"
                                        [ngClass]="{'filled': i < row.ratingAverage}"
                                        >
                                        &#9733;
                                        </span>
                                    </div>
                                </div>
                            </td>
                          </ng-container>
          
                          <ng-container matColumnDef="Actions">
                            <th mat-header-cell *matHeaderCellDef class="custom-mat-header-cell"> Actions </th>
                            <td mat-cell *matCellDef="let doc" class="mat-column-custom">
                              <!-- <div class="btns">
                              <button class="btn-action" (click)="editPOC(doc)">
                                <span class="material-symbols-outlined fs-16 " [ngbTooltip]="edit" tooltipClass="custom_tooltip"
                                    placement="bottom"
                                    triggers="manual" #edit1="ngbTooltip" (mouseleave)="edit1.close()"
                                    (mouseover)="edit1.open()">
                                    <ng-template #edit class="custom_tooltip">Edit</ng-template>
                                    edit
                                </span>
                              </button>
                              <button class="btn-action" (click)="openOutlookEmail(doc.pointofcontact)">
                                <span class="material-symbols-outlined  fs-18">mail</span>
                              </button>
                              <button class="btn-action" (click)="delPocCard(doc)">
                                <span class="material-symbols-outlined  fs-18">delete</span>
                              </button>
                            </div> -->
                            <div class="grid-actions d-flex align-items-center">
                                <div class="grid-comment">
                                    <button type="submit" class="msicon grid-comment-btn" (click)="viewRating(doc)">
                                        <span class="material-symbols-outlined fs-16 mr-2" matTooltip="View Comments"
                                        matTooltipPosition="above">comment</span>
                                    </button>
                                </div>
                                <div class="grid_card_menu">
                                    <div class="grid-dropdown d-flex">
                                        <!-- Dropdown Toggle Button -->
                                        <!-- <span class="material-symbols-outlined fs-16 cursor_pointer" id="dropdownMenuButton"
                                            (click)="toggleDropdown($event)">
                                            more_vert
                                        </span> -->
                                        <button mat-icon-button [matMenuTriggerFor]="menu" matRipple matRippleDisabled="true">
                                            <span class="material-symbols-outlined fs-16 cursor_pointer">
                                                more_vert
                                            </span>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button mat-menu-item *ngIf="isSuperAdmin" (click)="editPOC(doc)">
                                                <span class="material-symbols-outlined fs-16 mr-2">edit</span>
                                                Edit
                                            </button>
                                            <button mat-menu-item (click)="openOutlookEmail(doc.pointofcontact)">
                                                <span class="material-symbols-outlined fs-16 mr-2">mail</span>
                                                Contact
                                            </button>
                                            <button mat-menu-item *ngIf="isSuperAdmin" (click)="delPocCard(doc)">
                                                <span class="material-symbols-outlined fs-16 mr-2">delete</span>
                                                Delete
                                            </button>
                                        </mat-menu>
                                        <!-- Dropdown Menu -->
                                        <!-- <div class="grid-dropdown-menu" id="dropdownMenu">
                                            <a class="grid-dropdown-item cursor_pointer d-flex align-items-center" (click)="editPOC(doc)">
                                                <span class="material-symbols-outlined fs-16 mr-2">edit</span>
                                                <span>Edit</span>
                                            </a>
                                            <a class="grid-dropdown-item cursor_pointer d-flex align-items-center" (click)="openOutlookEmail(doc.pointofcontact)">
                                                <span class="material-symbols-outlined fs-16 mr-2">mail</span>
                                                <span>Contact</span>
                                            </a>
                                            <a class="grid-dropdown-item cursor_pointer d-flex align-items-center" (click)="delPocCard(doc)">
                                                <span class="material-symbols-outlined fs-16 mr-2">delete</span>
                                                <span>Delete</span>
                                            </a>
                                        </div> -->
                                    </div>
                                </div>
                            </div> 
                            </td>
                          </ng-container>
          
                        
                          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                          <tr class="mat-row no-data-row" *matNoDataRow>
                            <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length" style="text-align: center;">
                                <img src="../../../assets/images/no_data.png" height="120px"><br>
                                <span class="mt-3 d-block">
                                    <ng-container *ngIf="filterAttempted; else notFilter">
                                        No record found for selected criteria
                                    </ng-container>
                                    <ng-template #notFilter>
                                        <ng-container *ngIf="searchAttempted; else defaultMsg">
                                            No record found for search criteria
                                        </ng-container>
                                        <ng-template #defaultMsg>
                                            No Records Found
                                        </ng-template>
                                    </ng-template>
                                </span>
                            </td>
                        </tr>
                        </table>
                        <mat-paginator class="pagiantor" [length]="totalRecords" [pageSize]="size" [pageSizeOptions]="[5,10,20,50,100]" aria-label="Select page"
                        (page)="getPaginatorData($event)"></mat-paginator>
                    </div>
                </div>
                
                <div *ngIf="gridView === false && pocRecords?.length === 0 ">
                    <div class="noDataCard">
                      <div class="noDataCardIn">
                        <img src="../../../assets/images/no_data.png" height="120px"><br>
                            <span class="mt-3 d-block">
                                    <ng-container *ngIf="filterAttempted; else notFilter">
                                        No record found for selected criteria
                                    </ng-container>
                                    <ng-template #notFilter>
                                        <ng-container *ngIf="searchAttempted; else defaultMsg">
                                            No record found for search criteria
                                        </ng-container>
                                        <ng-template #defaultMsg>
                                            No Records Found
                                        </ng-template>
                                    </ng-template>
                            </span>
                      </div>
                    </div>
                  </div>
            </div>
            <div class="col-2 d-none d-lg-block most_items mb-3">
                <div class="row m-0 p-0">
                    <div class="col-12 d-flex justify-content-center p-0">
                        <!-- <span class="material-symbols-outlined mr-2 fs-18"> download </span> -->
                        <span class="mr-auto subtitle_card1 card1_styling align-self-center">Recently Viewed</span>
                    </div>
                    <div class="scrolldiv">
                        <div class="col-12 p-0 url cursor_pointer" *ngFor="let i of recentlyViewedList">
                          <div class="d-flex bodyCopy justify-content-center">
                            <span style="margin-right: 8px;">•</span>
                            <span class="mr-auto recentList">
                              <span>{{ i.title }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    <!-- <div class="col-12 p-1">
                        <div *ngIf="viewCount>5">
                            <span *ngIf="moreOrLess=='more'" class="link cursor_pointer" (click)="getMore('Recently Viewed')">+{{viewCount-5}} more</span>
                            <span *ngIf="moreOrLess=='less'" class="link cursor_pointer" (click)="getLess('Recently Viewed')">show less</span>
                        </div>
                    </div> -->
                    <div class="mt-20 border-top w-100"></div>
                    <div class="col-12 d-flex justify-content-center mt-20 p-0">
                        <!-- <span class="material-symbols-outlined mr-2 fs-18">visibility</span> -->
                        <span class="mr-auto subtitle_card1 card1_styling align-self-center">Recently Added</span>
                    </div>
                    <div class="scrolldiv">
                        <div class="col-12 p-0" *ngFor="let d of recentlyAddedList">
                            <div #divClick class=" d-flex bodyCopy justify-content-center">
                                <span style="margin-right: 8px;">•</span>
                                <span class=" mr-auto recentList">{{d.title}}</span>
                                <span style="margin-left: 15px;"></span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-12 p-1">
                        <div *ngIf="totalPocCount>5">
                            <span *ngIf="moreOrLess=='more'" class="link cursor_pointer" (click)="getMore('Recently Added')">+{{totalPocCount-5}} more</span>
                            <span *ngIf="moreOrLess=='less'" class="link cursor_pointer" (click)="getLess('Recently Added')">show less</span>
                        </div>
                    </div> -->
                    <div class="mt-20 border-top w-100"></div>
                    <div class="col-12 d-flex justify-content-center mt-20 p-0">
                        <!-- <span class="material-symbols-outlined mr-2 fs-18">visibility</span> -->
                        <span class="mr-auto subtitle_card1 card1_styling align-self-center">Top Rated</span>
                    </div>
                    <div class="scrolldiv">
                        <div class="col-12 p-0" *ngFor="let t of topRatedList">
                            <div #divClick class=" d-flex bodyCopy justify-content-center">
                                <span style="margin-right: 8px;">•</span>
                                <span class=" mr-auto recentList">{{t.title}}</span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-12 p-1">
                        <div *ngIf="ratedCount>5">
                            <span *ngIf="moreOrLess=='more'" class="link cursor_pointer" (click)="getMore('Top Rated')">+{{ratedCount-5}} more</span>
                            <span *ngIf="moreOrLess=='less'" class="link cursor_pointer" (click)="getLess('Top Rated')">show less</span>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>   
        
    </ng-container>
 </div>   
